import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _types$SEND_ABTEST_TO;
import * as types from './types';
export default (_types$SEND_ABTEST_TO = {}, _defineProperty(_types$SEND_ABTEST_TO, types.SEND_ABTEST_TOGGLE, function (state, newState) {
  state.abtestToggleState = newState;
}), _defineProperty(_types$SEND_ABTEST_TO, types.SEND_ABTEST_TOOLTYPE_TOGGLE, function (state, newState) {
  state.abtestToggleTooltypeState = newState;
}), _types$SEND_ABTEST_TO);